import { render } from "./PDFComponent.vue?vue&type=template&id=17ae0967&scoped=true"
import script from "./PDFComponent.vue?vue&type=script&lang=js"
export * from "./PDFComponent.vue?vue&type=script&lang=js"

import "./PDFComponent.vue?vue&type=style&index=0&id=17ae0967&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ae0967"]])

export default __exports__